var SearchVariants = (function ($) {

    SearchVariants = function (options) {
        var that = this;

        that.class = {
            direction: 'js-direction',
            direction_header: 'js-direction-header',
            direction_title: 'js-direction-title',
            variant: 'js-variant',
            variant_selected: 'selected',
            variant_direction_filter: 'js-variant-direction-filter',
            variant_direction_hidden_non_mobile: 'js-direction-hidden-non-mobile',
            flow_panel: 'js-flow-panel',
            flow_panel_hidden: 'panel-hidden',
            subsidy_container: 'js-subsidy-container',
            button_subsidy_select_passengers: 'js-select-passengers-button',
            action_subsidy_select_passengers: 'js-select-passengers',
            action_subsidy_selected_passengers: 'js-selected-passengers',
            subsidy_action_button_container: 'js-subsidy-action-button-container',
            search_form_container: 'js-search-form',
            modal_smartup_renew: 'js-modal-smartup-renew',
            smartup_hint_dynamic_low_segments: 'js-smartup-hint-dynamic-low-segments',
            route_share_link: '.js-route-share'
        };

        that.has_subsididized_passengers = options.has_subsidized_passengers || false;

        // DOM
        that.$wrapper = options['$wrapper'];
        that.$submit = that.$wrapper.find('.js-submit');
        that.$back_button = that.$wrapper.find('.js-back-button');
        that.$directions = that.$wrapper.find('.' + that.class.direction)
        that.$panel_wrapper = options['$panel_wrapper'];

        that.smartup_hint_modal = options['smartup_hint_modal'];
        that.smartup_hint_modal_empty = options['smartup_hint_modal_empty'];
        that.smartup_segment_limit = options['smartup_segment_limit'];
        that.search_passengers_count = options['search_passengers_count'];

        // CONST
        that.search_params_hash = options['search_params_hash'];
        that.search_params_string = options['search_params_string'];
        that.analytics_data = options['analytics_data'] || [];
        that.search_absolute_uri = options['search_absolute_uri'] || null;
        that.share_link_title = options['share_link_title'] || '';
        that.share_services = options['share_services'] || [];

        // DYNAMIC VARS
        that.selected_variant_prices = [];
        that.total_segments_count = 0;

        // INIT
        that.init();
    };

    SearchVariants.prototype.init = function () {
        var that = this;

        //
        that.initSearchVariants();
        //
        that.handlerSubmit();
        //
        that.initSubsidy();
        //
        that.handlerRenewSmartup();
        //
        that.initShareLink();
        //
        that.handlerLoader();
    };

    SearchVariants.prototype.initSearchVariants = function () {
        var that = this,
            $variants = that.$wrapper.find('.' + that.class.variant);

        $.each($variants, function (i, variant) {
            var $variant = $(variant),
                variant_hash = $variant.data('hash'),
                search_variant = new SearchVariant({
                    $wrapper: $variant,
                    smartup_hint_modal: that.smartup_hint_modal,
                    smartup_hint_modal_empty: that.smartup_hint_modal_empty,
                    analytics_data: that.analytics_data.find(item => item.hash === variant_hash),
                    onSelect: function (component) {
                        that.onVariantSelect($variant);
                        that.totalSegmentsCountIncrease(component.smartup_segments_charge_off);
                        that.validateSmartupSegmentsLimit();
                    },
                    onCancel: function (component, selected_price_hash) {
                        that.onVariantCancel($variant, selected_price_hash);
                        that.totalSegmentsCountDecrease(component.smartup_segments_charge_off);
                        that.validateSmartupSegmentsLimit();
                    },
                    onShowFareremark: function (variant_price_hash) {
                        var control_sign = md5(that.search_params_hash + variant_price_hash),
                            search_hash = [that.search_params_hash, variant_price_hash, control_sign];
                        $.sa.analytics.gtagSelectContent('reference', 'fareremark');
                        $.sa.analytics.reachGoal('fareremark', {source: 'SERP'});
                        $.uiFareremark({
                            search_hash: search_hash.join('-')
                        });
                    },
                });

            $variant.data('search_variant', search_variant);
        });
    };

    SearchVariants.prototype.onVariantSelect = function ($variant) {
        var that = this,
            $direction = $variant.parents('.' + that.class.direction),
            rt_possible = $variant.data('rt-possible');

        var selected_price_hash = $variant.data('search_variant').getSelectedPriceHash();
        if (selected_price_hash) {
            that.selected_variant_prices.push(selected_price_hash);
        }
        that.directionSelect($direction, rt_possible);
        that.toggleSelectedRouteShareLink($direction, selected_price_hash, true);
        that.calculateTotalPrice();
        that.flowPanelVisibility();
        that.variantDirectionFilterVisibility();
    };

    SearchVariants.prototype.onVariantCancel = function ($variant, before_cancel_selected_price_hash) {
        var that = this,
            $direction = $variant.parents('.' + that.class.direction)

        var selected_price_hash_index = that.selected_variant_prices.indexOf(before_cancel_selected_price_hash);
        if (selected_price_hash_index > -1) {
            that.selected_variant_prices.splice(selected_price_hash_index, 1);
        }

        that.directionReject($direction);
        that.toggleSelectedRouteShareLink($direction, null, false);
        that.calculateTotalPrice();
        that.flowPanelVisibility();
        that.variantDirectionFilterVisibility();
    };

    SearchVariants.prototype.directionSelect = function ($direction, next_direction_visible_variants, scroll_next_direction) {
        var that = this,
            $title_choose = $direction.find('.js-title-choose'),
            $title_selected = $direction.find('.js-title-selected');

        $title_choose.hide();
        $title_selected.show();

        var $direction_next = $direction.next('.' + that.class.direction);
        if (!$direction_next.length) {
            return false;
        }
        var $direction_next_header = $direction_next.find('.' + that.class.direction_header),
            $direction_next_variants = $direction_next.find('.' + that.class.variant);

        $direction_next_variants.hide();
        var next_direction_variants_rt_possible = false;
        $.each($direction_next_variants, function (i, variant) {
            var $variant = $(variant);
            if (next_direction_visible_variants.indexOf($variant.data('hash')) !== -1) {
                $variant.show();
                next_direction_variants_rt_possible = true;
            }
        });

        if (next_direction_variants_rt_possible) {
            $direction_next_header.show();
            $direction_next.show();
            if (scroll_next_direction) {
                $.sa.scrollToNode($direction_next_header);
            }
        }
    }

    SearchVariants.prototype.directionReject = function ($direction) {
        var that = this,
            $title_choose = $direction.find('.js-title-choose'),
            $title_selected = $direction.find('.js-title-selected'),
            $selected_variants = $direction.find('.' + that.class.variant + '.' + that.class.variant_selected),
            $direction_next = $direction.next('.' + that.class.direction);

        $title_choose.show();
        $title_selected.hide();

        $.each($selected_variants, function (i, selected_variant) {
            var $selected_variant = $(selected_variant);
            $selected_variant.data('search_variant').cancel();
        });

        if ($direction_next.length) {
            $direction_next.hide();
            that.directionReject($direction_next);
        }

        $.sa.scrollToNode($direction, 20);
    }

    SearchVariants.prototype.calculateTotalPrice = function () {
        var that = this,
            $flow_panel = that.$panel_wrapper,
            $total_amount = $flow_panel.find('.js-total-amount'),
            $total_amount_value = $total_amount.find('.js-total-amount-value'),
            total = 0,
            currency,
            total_price_formatted = '';

        var $selected_variants = that.$wrapper.find('.' + that.class.variant + '.' + that.class.variant_selected);
        $.each($selected_variants, function (i, selected_variant) {
            var $selected_variant = $(selected_variant);

            total += $selected_variant.data('search_variant').getSelectedPrice().data('total');

            if (!currency) {
                currency = $selected_variant.data('search_variant').getSelectedPrice().data('currency');
            }
        });

        if (total > 0) {
            total_price_formatted = $.sa.format.price(total, currency);
            $total_amount.show();
        } else {
            $total_amount.hide();
        }

        $total_amount_value.html(total_price_formatted);
    };

    SearchVariants.prototype.flowPanelVisibility = function () {
        var that = this,
            $flow_panel = that.$panel_wrapper;

        $.each(that.$directions, function (i, direction) {
            var $direction = $(direction),
                $direction_selected_variant = $direction.find('.' + that.class.variant + '.' + that.class.variant_selected);

            if (!$direction_selected_variant.length) {
                $flow_panel.addClass(that.class.flow_panel_hidden);
            } else
                $flow_panel.removeClass(that.class.flow_panel_hidden);
        });
    };

    SearchVariants.prototype.variantDirectionFilterVisibility = function () {
        var that = this;

        $.each(that.$directions, function (i, direction) {
            var $direction = $(direction),
                $variant_direction_filter = $direction.find('.' + that.class.variant_direction_filter),
                $direction_selected_variant = $direction.find('.' + that.class.variant + '.' + that.class.variant_selected);

            $variant_direction_filter.each(function (){
                var $filter = $(this);

                if (!$direction_selected_variant.length) {
                    if ($filter.hasClass(that.class.variant_direction_hidden_non_mobile)) {
                        $filter.css('display', 'flex');
                    } else {
                        $filter.show();
                    }
                } else {
                    $filter.hide();
                }
            });
        });
    };

    SearchVariants.prototype.handlerLoader = function () {
        var that = this;

        $.sa.$document.one('avia_before_load', function (){
            that.__lockFlowButtons(true);
        });

        $.sa.$document.one('avia_after_load', function (){
            that.__lockFlowButtons(false);
        });
    }

    SearchVariants.prototype.__lockFlowButtons = function (state) {
        var that = this;

        that.$submit.prop('disabled', state);

        if (state === true) {
            that.$submit.addClass('events-none');
            that.$back_button.addClass('events-none');
        } else {
            that.$submit.removeClass('events-none');
            that.$back_button.removeClass('events-none');
        }
    }

    SearchVariants.prototype.handlerSubmit = function () {
        var that = this;

        that.$submit.on('click', function () {
            $.sa.content_router.load(that.buildPassengersPageUrl());
            $.sa.buttonLoading(that.$submit, true);
        });
    }

    SearchVariants.prototype.buildPassengersPageUrl = function () {
        var that = this,
            variants_prices_hash = that.selected_variant_prices.join('!'),
            control_sign = md5(that.search_params_hash + variants_prices_hash),
            url_chunks = [
                that.search_params_hash,
                variants_prices_hash,
                control_sign
            ];

        return $.sa.build_url('search/passengers') + '/' + url_chunks.join('-');
    }

    SearchVariants.prototype.handlerRenewSmartup = function () {
        var that = this,
            $button = that.$wrapper.find('.' + that.class.modal_smartup_renew);

        $button.on('click', function (e) {
            e.preventDefault();
            that.renderSmartupRenewModal();
        });
    }

    SearchVariants.prototype.renderSmartupRenewModal = function () {
        var that = this,
            html = that.smartup_hint_modal_empty;

        $.uiModal({
            html: html
        });
    }

    SearchVariants.prototype.totalSegmentsCountIncrease = function (segments_qty) {
        var that = this;
        that.total_segments_count += segments_qty;
    };

    SearchVariants.prototype.totalSegmentsCountDecrease = function (segments_qty) {
        var that = this;
        that.total_segments_count -= segments_qty;
    }

    SearchVariants.prototype.smartupLowSegmentsHintShow = function () {
        var that = this,
            $hint = that.$wrapper.find('.' + that.class.smartup_hint_dynamic_low_segments);

        $hint.show();
    }

    SearchVariants.prototype.smartupLowSegmentsHintHide = function () {
        var that = this,
            $hint = that.$wrapper.find('.' + that.class.smartup_hint_dynamic_low_segments);

        $hint.hide();
    }

    SearchVariants.prototype.validateSmartupSegmentsLimit = function () {
        var that = this,
            passengers_segments = that.total_segments_count * that.search_passengers_count;

        if (!that.smartup_segment_limit) {
            return false;
        }

        if (passengers_segments > that.smartup_segment_limit) {
            that.smartupLowSegmentsHintShow();
        } else {
            that.smartupLowSegmentsHintHide();
        }
    }

    SearchVariants.prototype.initSubsidy = function () {
        var that = this,
            $subsidy_container = that.$wrapper.find(`.${that.class.subsidy_container}`),
            $search_form = $(`.${that.class.search_form_container}`),
            $action_subsidy_select_passengers = $subsidy_container.find(`.${that.class.action_subsidy_select_passengers}`),
            $action_subsidy_selected_passengers = $subsidy_container.find(`.${that.class.action_subsidy_selected_passengers}`),
            $button_subsidy_select_passengers = $subsidy_container.find(`.${that.class.button_subsidy_select_passengers}`),
            $subsidy_action_button_container = $subsidy_container.find(`.${that.class.subsidy_action_button_container}`),
            setActionButton = function (state) {
                if (state) {
                    $button_subsidy_select_passengers.removeClass('secondary').addClass('light large');
                    $subsidy_action_button_container.addClass('subsidy-passengers-selected');
                    $action_subsidy_select_passengers.hide();
                    $action_subsidy_selected_passengers.show();
                } else {
                    $button_subsidy_select_passengers.removeClass('light large').addClass('secondary');
                    $subsidy_action_button_container.removeClass('subsidy-passengers-selected');
                    $action_subsidy_selected_passengers.hide();
                    $action_subsidy_select_passengers.show();
                }
            };

        if ($subsidy_container.length) {
            if (that.has_subsididized_passengers) {
                $subsidy_container.find('.selected-passengers-count')
                                  .text($search_form.find('.js-passengers-count-input.js-field-value').val());
            }
            setActionButton(that.has_subsididized_passengers);
            $subsidy_container.on('click', `.${that.class.button_subsidy_select_passengers}`, () => $search_form.trigger('open_passengers'));
            $search_form.find('.js-passengers-count-input').off('.subsidy').on('change.subsidy', function () { // get jquery-element dynamically (do not save into variable), and select by class '.js-passengers-count-input', which both mobile and desktop elements have - to prevent bugs when window size changed from desktop to mobile
                $subsidy_container.find('.selected-passengers-count').text($search_form.find('.js-passengers-count-input.js-field-value').val());
            });
            $search_form
                .off('subsidy_change')
                .off('direction_change')
                .on('subsidy_change', function (event, value) {
                    setActionButton(value.state);
                })
                .on('direction_change', function (event, value) {
                    if (value.subsidized) {
                        that.$wrapper.find(`.${that.class.subsidy_container}`).show();
                    } else {
                        that.$wrapper.find(`.${that.class.subsidy_container}`).hide();
                    }
                });
        }
    };

    SearchVariants.prototype.initShareLink = function () {
        var that = this;

        that.$wrapper.find(`${that.class.route_share_link}`)
            .on('click.route_share_link', function () {
                var $this = $(this),
                    uri = $this.data('link');

                if (!uri || !that.search_absolute_uri || !that.share_link_title.length) {
                    return;
                }

                var link_params = {
                        utm_source: 'internally',
                        utm_medium: 'share_link',
                        utm_campaign: 'serp',
                        utm_content: '%s',
                        utm_term: dayjs().format('YYYY-MM-DD')
                    },
                    og_image = $.sa.og.get('image'),
                    og_description = $.sa.og.get('description');

                uri += uri.includes('?') ? '&' : '?';

                // URLSearchParams will not work here because it escapes special characters.
                // Because of this, placeholders do not work. :(
                link_params = Object.keys(link_params).map(function(key) {
                    return key + '=' + link_params[key];
                }).join('&');

                var share_url = that.search_absolute_uri
                    + (that.search_absolute_uri.endsWith('/') ? '' : '/')
                    + uri
                    + link_params;

                var share_options = {
                    url: share_url,
                    services: that.share_services,
                    title: that.share_link_title
                };

                // Try to get OpenGraph image with fallback to the default
                if (og_image && og_image.length) {
                    share_options.image = og_image;
                }

                if (og_description && og_description.length) {
                    share_options.description = og_description;
                }

                $.sa.share(share_options);
            });
    };

    SearchVariants.prototype.toggleSelectedRouteShareLink = function ($direction, price_hash, status) {
        var that = this,
            $share_link = $direction.find(that.class.route_share_link);

        if (!$share_link.length) {
            return;
        }
        $share_link.toggle(status);

        if (status && price_hash) {
            $share_link.data('link', that.search_params_string + '?v=' + price_hash)
        } else {
            $share_link.data('link', null);
        }
    };

    return SearchVariants;

})(jQuery);
